import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { HttpClient } from '@angular/common/http';
import { RegionsModel } from '../models/manageRegions/regions.model';
import { catchError, map } from 'rxjs/operators';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ManageRegionsService {
  private host = environment.apiUrl + "regions/manageregions";
  public loggedinUser: string = '';
  opts = [];
  optsArea = [];
  optsRegion = [];

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
    console.log('ManageRegionsService login name ', this.loggedinUser);
  }

  getAutoMajorAreasData() {
    this.opts = [];
    console.log("getAutoMajorAreasData");
    let url = this.host + '/getmajorareas';
    return this.opts.length ?
      of(this.opts) :
      this.http.get<any>(url).pipe(tap(data => this.opts = data))
  }

  getAutoAreasData() {
    this.optsArea = [];
    console.log("getAutoAreasData");
    let url = this.host + '/getallareas';
    return this.optsArea.length ?
      of(this.optsArea) :
      this.http.get<any>(url).pipe(tap(data => this.optsArea = data))
  }


  getAutoRegionsData() {
    this.optsRegion = [];
    console.log("getAutoRegionsData");
    let url = this.host + '/getallregions';
    return this.optsRegion.length ?
      of(this.optsRegion) :
      this.http.get<any>(url).pipe(tap(data => this.optsRegion = data))
  }

  public getMAreas(searchVal: string): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getmareas/` + searchVal);
  }

  public getMajorAreas(): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getmajorareas`);
  }

  public getActiveMajorAreas(): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getactivemajorareas`);
  }

  public getActiveCorps(): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getactivecorps`);
  }

  public getExcelManageRegions(): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getallmanageregions`);
  }

  public getRegions(majorArea: string): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getregions/` + majorArea);
  }

  public getAreas(majorArea: string, region: string): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getareas/` + majorArea + '/' + region);
  }


 

  public getCorps(formData: FormData): Observable<RegionsModel[]> {
    return this.http.post<RegionsModel[]>(`${this.host}/getcorps`, formData);
  }



  public getAllAreas(): Observable<RegionsModel[]> {
    return this.http.get<RegionsModel[]>(`${this.host}/getallareas`);
  }

  public addMajorArea(formData: FormData): Observable<RegionsModel> {
    return this.http.post<RegionsModel>(`${this.host}/insertmajorarea`, formData);
  }

  public updateCorp(formData: FormData): Observable<RegionsModel> {
    return this.http.post<RegionsModel>(`${this.host}/updatecorp`, formData);
  }

  public updateMajorArea(formData: FormData): Observable<RegionsModel> {
    return this.http.post<RegionsModel>(`${this.host}/updatemajorarea`, formData);
  }
  public updateRegion(formData: FormData): Observable<RegionsModel> {
    return this.http.post<RegionsModel>(`${this.host}/updateregion`, formData);
  }
  public updateArea(formData: FormData): Observable<RegionsModel> {
    return this.http.post<RegionsModel>(`${this.host}/updatearea`, formData);
  }

  public createForm(addData: RegionsModel): FormData {
    const formData = new FormData();
    formData.append('id', addData.id);
    formData.append('corp', addData.corp);
    formData.append('majorarea', addData.majorarea);
    formData.append('region', addData.region);
    formData.append('area', addData.area);
    formData.append('currentUser', this.loggedinUser);
    console.log("formData: " + formData);
    return formData;
  }

  public createUpForm(addData: RegionsModel, orgname): FormData {

    const formData = new FormData();
    formData.append('orgname', orgname);
    formData.append('majorarea', addData.majorarea);
    formData.append('region', addData.region);
    formData.append('area', addData.area);
    formData.append('currentUser', this.loggedinUser);
    console.log("formData: " + formData);
    return formData;
  }

  public createUpdateForm(addData: RegionsModel, corpStatus, mainCorpName): FormData {
    const formData = new FormData();
    formData.append('corp', addData.corp);
    formData.append('area', addData.area);
    formData.append('status', addData.status);
    formData.append('fieldstatus', corpStatus);
    formData.append('mainCorpName', mainCorpName);
    formData.append('currentUser', this.loggedinUser);
    console.log("formData: " + formData);
    return formData;
  }

  public getCorpsForm(majorAreaName: string, regionName: string, areaName: string): FormData {
    console.log("majorAreaName = " + majorAreaName);
    var formData = new FormData();
    formData.append('majorarea', majorAreaName);
    formData.append('region', regionName);
    formData.append('area', areaName);

    new Response(formData).text().then(console.log)
    return formData;
  }



}
